import { Inventory, getMpNodeAgent } from '@cibo/core'
import { downloadTextFile } from '../../consts/Theme'

export const downloadReportData = async (inventory: Inventory) => {
  const agent = getMpNodeAgent()
  const PATH = `/inventories/download?inventoryId=${inventory.inventoryId}`

  return agent.get(PATH).then(response => {
    downloadTextFile({
      textContent: response.data as string,
      filename: `${inventory.name}.csv`,
      mimetype: 'text/csv',
    })
  })
}
